const academiaIa = {
  readFacturacionAcademiaCompradores: 'academia-ia/academias/{{uuid_academia}}/facturacion/compradores',
  readFacturacionAcademias: 'academia-ia/academias/facturacion',
  readFacturacionAcademiasTotales: 'academia-ia/academias/facturacion/totales'
}

export default academiaIa
